import { Injectable, Output, EventEmitter, Inject } from '@angular/core';
import { environment as env } from 'environments/environment';

import * as io from 'socket.io-client';

@Injectable()
export class SocketConnection {
  @Output() onSocketStatusChanged: EventEmitter<any> = new EventEmitter();
  @Output() onSocketRoomStatusChanged: EventEmitter<any> = new EventEmitter();
  @Output() onAuthenticationStatusChanged: EventEmitter<any> = new EventEmitter(); //Send Authentication Object 
  @Output() onAuthentication: EventEmitter<any> = new EventEmitter(); //Send Authentication
  @Output() onRoomDisconnection: EventEmitter<any> = new EventEmitter(); //ENDED CALL
  @Output() onNotify: EventEmitter<any> = new EventEmitter(); //Broadcast Message

  @Output() onIncomingCall: EventEmitter<any> = new EventEmitter(); //INCOMING CALL
  @Output() onOutgoingCall: EventEmitter<any> = new EventEmitter(); //OUTGOING CALL
  @Output() onConnectedCall: EventEmitter<any> = new EventEmitter(); //INCOMING CALL
  @Output() onEndedCall: EventEmitter<any> = new EventEmitter(); //ENDED CALL

  @Output() onCallerSelected = new EventEmitter();

  @Output() onDeliveryCompleted = new EventEmitter();
  @Output() onRequestDeliveryLocation = new EventEmitter();
  @Output() onProvideDeliveryLocation = new EventEmitter();

  //SecureSocketURL: string = env.SecureSocketURL;

  socketURL: string = env.SocketURL;
  socket: any;

  // AuthTokenObject: AuthTokenClass = new AuthTokenClass();

  SocketStatus: string;
  isSocketConnected: boolean;

  SocketRoomStatus: string;
  isSocketRoomConnected: boolean;

  CallerInstance: any;

  constructor(public RoomGuid: string) { }

  Close_Socket_Connection() {
    //this.socket.emit('closeConnection')

  }

  Initialize_Socket_Connection() {


    //   try {
    //     this.socket = io.connect(this.socketURL, {
    //       reconnection: true,
    //       reconnectionDelay: 1000,
    //       reconnectionDelayMax: 5000,
    //       reconnectionAttempts: Infinity,
    //       secure: true,
    //       //rejectUnauthorized: false //Added cause on mobile app --> xhr poll error
    //       // forceNew:true,
    //     });
    // } catch (ex) {
    //   console.log(ex)
    // }

    this.socket = io.connect(this.socketURL, {
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
      secure: true,
      
     
      //FOR ANDROID TO AVOID - was loaded over HTTPS, but requested an insecure XMLHttpRequest endpoint - Error: xhr poll error
      // rejectUnauthorized: false, //Added cause on mobile app --> xhr poll error
      // forceNew:true,
    });

    //  this.socket.on('connect', function () { console.log('connected to server'); });
    //  this.socket.on('disconnect', function () { console.log('disconnected from server'); });
    //  this.socket.on('reconnect', function () { console.log('reconnect from server'); });
    //  this.socket.on('reconnecting', function () { console.log('reconnecting to server'); });

    this.socket.on('connect', () => {
      console.log('Socket Server is ONLINE')
      //This executed every time client is Connected or Reconnected after disconnection
      //We need to Register the Client to Private Room in order to be able to receive from Windows Client
      this.set_SocketStatus("Socket Server is ONLINE", true);


      this.socket.emit('register', this.RoomGuid);

      // if (this.AuthTokenObject) { //IF OBJECT EXIST THEN MEANS THAT AN AUTHENTICATION PROCESS MUST BE VERIFIED 


      //   if (this.AuthTokenObject.isAuthenticated && isGuid(this.AuthTokenObject.RoomGuid)) {

      //     this.set_SocketRoomStatus("Reconnecting to CallCenter....", false);

      //     this.AuthTokenObject.AuthenticationStatus = "Verifying Authentication..."
      //     this.set_AuthenticationStatus(this.AuthTokenObject)


      //     //SET A DELAY FOR THE CLIENT 
      //     //CLIENT MIGHT RECONNECT BEFORE WINDOWS SERVER CONNECT AND RE-CREATE ROOM
      //     //When back Online then Verify Authentication and Register Room if Verified
      //     //setTimeout(() => {  
      //     this.Request_Authentication_Verification(this.AuthTokenObject)
      //     //}, 5000);

      //   }
      // }


    })

    //SOCKET DISCONNECTION SIGNAL -- Notify Application for Alert User
    this.socket.on('Room_Disconnection', () => { this.onRoomDisconnection.emit(); })



    //SOCKET CONNECTION MONITORING STATUS
    this.socket.on('disconnect', () => {
      console.log('Socket Server is OFFLINE')
      this.set_SocketStatus("Socket Server is OFFLINE", false);
      this.set_SocketRoomStatus("CallCenter Communication Unknown", false);

      //TODO What happens when we lost SOCKET SERVER and Client is Authenticated
      // if (this.AuthTokenObject) {
      //   this.AuthTokenObject.AuthenticationStatus = "Authentication Status Unknown"
      //   this.set_AuthenticationStatus(this.AuthTokenObject)
      // }

    })

    this.socket.on('reconnecting', () => {
      console.log('Connecting to Socket Server........')
      this.set_SocketStatus("Connecting to Socket Server........", false);
    })

    this.socket.on('connect_error', (err) => {
      console.log('ERROR Connecting to Socket Server')
      console.log(err)
      this.set_SocketStatus("ERROR Connecting to Socket Server", false);
    })


    //AUTHENTICATION / VERIFICATION PROCESSES

    //01. Request Authentication [ Procedure Below ] --> TO SOCKET SERVER

    //02. Authentication Failed From Socket Server
    //    Room Defined not EXIST Anymore
    //    Force Client to Reset Authentication Token. NOT VALID ANYWAY
    // this.socket.on('Reset-Authentication', () => {
    //   //TODO Odysseas
    //   //Bypass if Manual sign IN
    //   if (this.userData.AuthTokenObject.AuthType === "CallCenter")
    //     this.userData.ClearAuthenticationObject()
    // })

    // 03. Response Authentication  <-- FROM SOCKET SERCER
    // this.socket.on('Response-Authentication', (_AuthTokenObject) => {
    //   let _self = this;

    //   //Set to AuthTokenObject to Remove SocketClientID Not needed cause multi Clients can login from this Session
    //   this.AuthTokenObject = JSON.parse(_AuthTokenObject);

    //   //Save Authentication to Storage
    //   if (this.AuthTokenObject.isAuthenticated) {

    //     // SAVE Authentication Object to Local Storage
    //     _self.AuthTokenObject.isSocketConnected = true;
    //     _self.AuthTokenObject.IsCallCenterAuth = true;
    //     _self.AuthTokenObject.AuthType = "CallCenter"
    //     _self.AuthTokenObject.AuthenticationStatus = "Authenticated"

    //     _self.userData.setAuthenticationObject(_self.AuthTokenObject)

    //     //Notify Client that is authenticated
    //     _self.onAuthentication.emit(_self.AuthTokenObject);

    //   } else {

    //     _self.AuthTokenObject.AuthenticationStatus = "Authentication Failed."
    //     _self.set_AuthenticationStatus(_self.AuthTokenObject)

    //     _self.userData.ClearAuthenticationObject();


    //   }

    // })

    // 03. Authentication Verification Process [ Procedure Below ] --> TO SOCKET SERVER


    // 04. Response Authentication Verification <-- FROM SOCKET SERVER
    // this.socket.on('Response-Authentication-Verification', (data) => {

    //   let _self = this;


    //   //Set to AuthTokenObject to Remove SocketClientID Not needed cause multi Clients can login from this Session
    //   _self.AuthTokenObject = JSON.parse(data);

    //   //Save Authentication to Storage
    //   if (_self.AuthTokenObject.isAuthenticated) {
    //     // this.storage.set("Athentication",this._AuthTokenObject)
    //     _self.AuthTokenObject.isSocketConnected = true;
    //     _self.AuthTokenObject.IsCallCenterAuth = true;
    //     _self.AuthTokenObject.AuthType = "CallCenter"
    //     _self.AuthTokenObject.AuthenticationStatus = "Authenticated"

    //     _self.userData.setAuthenticationObject(_self.AuthTokenObject)

    //     //Notify Client that is authenticated
    //     _self.onAuthentication.emit(_self.AuthTokenObject);


    //   } else {

    //     _self.set_SocketRoomStatus("CallCenter Communication Unknown", false);
    //     _self.AuthTokenObject.AuthenticationStatus = "Authentication Failed."
    //     _self.set_AuthenticationStatus(_self.AuthTokenObject)

    //   }

    // })




    //CALL ACTIVITIES

    // 01. INCOMING CALL  <-- FROM SOCKET SERCER
    this.socket.on('Incoming-Call', (_CallerInstance) => {

      let _self = this;
      console.log("Incoming call from socket")

      _self.CallerInstance = JSON.parse(_CallerInstance);
      console.log(JSON.parse(_CallerInstance))
      //Notify Client for Incoming Call passing the Caller Object
      _self.onIncomingCall.emit(_self.CallerInstance);

    })

    // 02. OUTGOING CALL  <-->  SOCKET SERCER
    this.socket.on('Outgoing-Call', (_CallerInstance) => {
      let _self = this;

      // console.log("Outgoing call")

      _self.CallerInstance = JSON.parse(_CallerInstance);

      //Notify Client for Incoming Call passing the Caller Object
      _self.onOutgoingCall.emit(_self.CallerInstance);

    })

    // 03. CONNECTED CALL  <-- FROM SOCKET SERCER
    this.socket.on('Connected-Call', (_CallerInstance) => {
      let _self = this;

      // console.log("Connected call")

      _self.CallerInstance = JSON.parse(_CallerInstance);
      console.log(JSON.parse(_CallerInstance))
      //Notify Client for Incoming Call passing the Caller Object
      _self.onConnectedCall.emit(_self.CallerInstance);

    })

    // 04. ENDED CALL  <-- FROM SOCKET SERCER

    this.socket.on('Ended-Call', (_CallerInstance) => {

      this.CallerInstance = JSON.parse(_CallerInstance);
      console.log(JSON.parse(_CallerInstance))
      // console.log("Ended call")

      //Save Authentication to Storage
      // if (_self._AuthTokenObject.isAuthenticated) {
      //   // this.storage.set("Athentication",this._AuthTokenObject)
      //   this.userData.setAuthentication(this._AuthTokenObject);
      // }

      //Notify Client for Incoming Call passing the Caller Object
      this.onEndedCall.emit(this.CallerInstance);


    });




    //DELIVERY SOCKET COMMUNICATION
    this.socket.on('Delivery-Completed', (_DeliveryInstance) => {

      //this.CallerInstance = JSON.parse(_DeliveryInstance);
      //console.log(JSON.parse(_DeliveryInstance))
      console.log("Delivery Completed via Socket")

      //Notify Client for Incoming Call passing the Caller Object
      this.onDeliveryCompleted.emit(_DeliveryInstance);


    });


    this.socket.on('Request-Delivery-Location', (_RoomID) => {

      //this.CallerInstance = JSON.parse(_DeliveryInstance);
      //console.log(JSON.parse(_DeliveryInstance))
      console.log("Request-Delivery-Location")

      //Notify Client for Incoming Call passing the Caller Object
      this.onRequestDeliveryLocation.emit(_RoomID);


    });


    this.socket.on('Provide-Delivery-Location', (_DeliveryLocationInstance) => {

      //this.CallerInstance = JSON.parse(_DeliveryInstance);
      console.log(JSON.parse(_DeliveryLocationInstance))
      console.log("Provide-Delivery-Location")

      //Notify Client for Incoming Call passing the Caller Object
      this.onProvideDeliveryLocation.emit(_DeliveryLocationInstance);


    });



    //BROADCAST MESSAGE TO ALL CLIENTS
    //To all connected clients Message Broadcast

    // this.socket.on('notification', (_notification) => {
    //   let _self = this;
    //   _self.onNotify.emit(_notification);
    //   // //console.log("Message Received : " + _notification);
    // });


  } //END OF INITIALIZATION



  emit(_eventName, data) {
    this.socket.emit(_eventName, JSON.stringify(data));
  }

  // emitRoom(RoomGuid,_eventName, data) {
  //   this.socket.to(RoomGuid).emit(_eventName, JSON.stringify(data));
  // }



  //NOT USED SO FAR -- NOT WORING WHEN CALLED FROM OTHER PAGES
  get_SocketStatus(): string { return this.SocketStatus; };

  //SOCKET SERVER STATUS
  set_SocketStatus(_Status: string, _isConnected: boolean): void {
    let _self = this;
    _self.SocketStatus = _Status;
    _self.isSocketConnected = _isConnected;


    // _self.AuthTokenObject.isSocketConnected = _isConnected;
    // _self.userData.setAuthenticationObject(_self.AuthTokenObject)

    _self.onSocketStatusChanged.emit({ SocketStatus: _self.SocketStatus, isSocketConnected: _self.isSocketConnected });
  };

  //SOCKET SERVER ROOM STATUS
  set_SocketRoomStatus(_Status: string, _isConnected: boolean): void {
    let _self = this;
    _self.SocketRoomStatus = _Status;
    _self.isSocketRoomConnected = _isConnected;
    _self.onSocketRoomStatusChanged.emit({ SocketRoomStatus: _self.SocketRoomStatus, isSocketRoomConnected: _self.isSocketRoomConnected });
  };

  set_AuthenticationStatus(_AuthTokenObject): void {
    this.onAuthenticationStatusChanged.emit(_AuthTokenObject);
  };


  // 01. Request Authentication
  // Request_Authentication(_AuthTokenObject: AuthTokenClass): void {
  //   let _self = this;

  //   //GET AUTHENTICATION TOKEN OBJECT 
  //   _self.AuthTokenObject = _AuthTokenObject;

  //   //Check IF Socket is ALIVE!! ( this.socket.connected = [ TRUE | FALSE ]
  //   if (this.socket.connected) {

  //     this.socket.emit('Request-Authentication', JSON.stringify(_AuthTokenObject), function (callback) {
  //       _self.AuthTokenObject.AuthenticationStatus = callback;
  //       _self.AuthTokenObject.isSocketConnected = true;
  //       _self.AuthTokenObject.IsCallCenterAuth = true;
  //       _self.AuthTokenObject.AuthType = "CallCenter"

  //       _self.set_AuthenticationStatus(_self.AuthTokenObject)
  //       _self.userData.setAuthenticationObject(_self.AuthTokenObject)
  //     })

  //   }
  //   else {

  //     _self.set_SocketRoomStatus("Request Authentication failed socket server is OFFLINE", false);
  //     _self.AuthTokenObject.AuthenticationStatus = "Authentication Failed."
  //     _self.AuthTokenObject.isSocketConnected = false;
  //     //_self.AuthTokenObject.IsCallCenterAuth = true;
  //     //_self.AuthTokenObject.AuthType = "CallCenter"
  //     _self.set_AuthenticationStatus(_self.AuthTokenObject)

  //     //THIS IS SAFE CAUSE IS THE FIRST TIME USER REQUEST AUTHENTICATION
  //     //Which means that object did not exist anyway
  //     //WHEN SOCKET WILL BE AVAILABLE THE CLIENT WILL HAVE TO RETRY AUTHENTICATION PROCESS
  //     //_self.storage.clear();  //Clear all storage values
  //     _self.userData.ClearAuthenticationObject();

  //   }


  //   //this.socket.emit('Request-Authentication', JSON.stringify(_AuthTokenObject));
  //   // _self.set_SocketRoomStatus("Request Authentication From Socket Server", false);


  //   // } else {

  //   //   _self.set_SocketRoomStatus("Authentication Process Failed Wrong Code Provided", false);

  //   //   _AuthTokenObject.AuthToken = null;
  //   //   _AuthTokenObject.AuthSalt = null;
  //   //   _AuthTokenObject.isAuthenticated = false;
  //   //   _AuthTokenObject.AuthenticationStatus = "Not Authenticated";

  //   //   //RESET AUTHENTICATION FROM LOCAL STORAGE
  //   //   this.userData.setAuthentication(this._AuthTokenObject)

  //   //   //Response to Client  
  //   //   _self.onAuthentication.emit(_AuthTokenObject);

  //   //   //TODO ( Optional ) Destroy Socket Connection 

  //   // }
  // };

  //03. Authentication Verification Process
  // Request_Authentication_Verification(_AuthTokenObject: AuthTokenClass): void {
  //   let _self = this;

  //   _self.AuthTokenObject = _AuthTokenObject;

  //   //Check IF Socket is ALIVE!! ( this.socket.connected = [ TRUE | FALSE ]
  //   if (this.socket.connected) {
  //     this.socket.emit('Request-Authentication-Verification', JSON.stringify(_AuthTokenObject), function (callback) {
  //       _self.AuthTokenObject.AuthenticationStatus = callback;
  //       _self.AuthTokenObject.IsCallCenterAuth = true;
  //       _self.AuthTokenObject.AuthType = "CallCenter"

  //       _self.set_AuthenticationStatus(_self.AuthTokenObject)
  //       _self.set_SocketRoomStatus("Request Authentication Verification From CallCenter Server", false);
  //       _self.userData.setAuthenticationObject(_self.AuthTokenObject)
  //     })

  //   }
  //   else {
  //     _self.set_SocketRoomStatus("Request Authentication Verification failed socket server is OFFLINE", false);
  //     _self.AuthTokenObject.AuthenticationStatus = "Authentication Verification Failed."
  //     _self.AuthTokenObject.isAuthenticated = false;
  //     _self.set_AuthenticationStatus(_self.AuthTokenObject)
  //   }

  // };


  // Request_Room_Registration(_AuthTokenObject: AuthTokenClass): void {
  //   let _self = this;

  //   //Check IF Socket is ALIVE!! ( this.socket.connected = [ TRUE | FALSE ]
  //   if (this.socket.connected) {

  //     this.socket.emit('Request-Room-Registration', JSON.stringify(_AuthTokenObject), function (callback) {
  //       _self.set_SocketRoomStatus(callback, true);
  //     })
  //   } else {
  //     _self.set_SocketRoomStatus("Request CallCenter Registration failed socket server is OFFLINE", true);
  //     //Retry Process will be handle by Socket Monitoring 
  //     //When Back Online and isAuthenticated the Register to Room
  //   }

  // };


  //CALLING SECTION

  //Validation of Phone Number might Required
  // Request_Outgoing_Call(CallPhoneObject: any) {
  //   this.socket.emit('Dialing-Call', JSON.stringify(CallPhoneObject));
  // }

  Send_Delivery_Completed_Notification_via_Socket(DeliveryCompletedInstance: any) {
    this.socket.emit('Delivery-Completed', JSON.stringify(DeliveryCompletedInstance));
  }


  ConnectToRoom(_RoomID) {
    this.socket.emit('register', _RoomID);
  }

  DisconnectFromRoom(_RoomID) {
    this.socket.emit('unregister', _RoomID);
  }

  RequestRemoteLocation(_RoomID) {
    this.socket.emit('Request-Delivery-Location', _RoomID);
  }

  ProvideDeliveryLocation(_DeliveryLocationInstance: any) {
    this.socket.emit('Provide-Delivery-Location', JSON.stringify(_DeliveryLocationInstance));
  }



} //END OF CLASS

function isGuid(stringToValidate) {
  try {

    if (stringToValidate[0] === "{") {
      stringToValidate = stringToValidate.substring(1, stringToValidate.length - 1);
    }

    var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
    return regexGuid.test(stringToValidate);
  }
  catch (err) { return false }

}